<search-dialog-page [model]="model" (onAction)="action($event)">
  <!--INSERT Search Content HERE IN DESCENDANT-->
</search-dialog-page>
